import {Component, Injector, Input} from '@angular/core';
import {DraftsService} from '../../services/drafts.service';
import {BasePageComponent} from "../../../base/components/base-page.component";
import {DraftsResearchModel} from "../../models/drafts-research.model";
import {Observable} from "rxjs";
import {DraftModel} from "../../models/draft.model";
import {DraftsResearchFilterModel} from "../../models/drafts-research-filter.model";
import {DraftsResearchFilter1Model} from "../../models/drafts-research-filter1.model";
import {ClientAccountService} from "../../../shared/services/client-account.service";
import {Router} from "@angular/router";
import {UsersService} from "../../../shared/services/users.service";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {MessageType} from "../../../shared/constants/message-type.constant";

declare var $: any;

@Component({
  selector: 'app-drafts',
  templateUrl: './drafts.component.html',
  styleUrls: ['./drafts.component.scss']
})
export class DraftsComponent extends BasePageComponent {
  searchLoading: boolean;
  searchResults: Array<DraftModel>;
  deleteMode: boolean;
  switchDraft: FormGroup;
  draftToEdit: DraftModel;
  @Input() boxView: boolean = false;
  @Input() onlyLast: boolean = false;

  constructor(injector: Injector, public fb: FormBuilder, private draftsService: DraftsService, private clientAccountService: ClientAccountService, public router: Router, private usersService: UsersService) {
    super(injector);
    this.createForm();

  }

  public isSearchLoading() {
    return this.searchLoading;
  }

  public startSearchLoading() {
    this.searchLoading = true;
  }

  public stopSearchLoading() {
    this.searchLoading = false;
  }

  buildCriteriaDto(): any {
    let draftsResearchModel: DraftsResearchModel = new DraftsResearchModel();
    draftsResearchModel.filter = new DraftsResearchFilterModel();
    draftsResearchModel.filter.accountCode = this.clientAccountService.getAccount()?.accountCode || null;
    draftsResearchModel.filter.customerCode = this.clientAccountService.getClient()?.customerCode || null;
    draftsResearchModel.filter.unit = this.clientAccountService.getAccount()?.accountCode || null;
    draftsResearchModel.options = new DraftsResearchFilter1Model();
    draftsResearchModel.options.onlyMyDrafts = this.switchDraft.get('onlyMyDraft').value;
    draftsResearchModel.options.lastDrafts = this.onlyLast;
    return draftsResearchModel;
  }

  ngOnInitForChildren(): void {
    this.startSearchLoading();

    this.search(this.buildCriteriaDto())
      .subscribe((res) => {
          this.searchResults = res;
          this.stopSearchLoading();
        },
        err => {
          this.stopSearchLoading();
        });
  }

  ngOnDestroyForChildren(): void {
    $('body').off();
  }

  pageName(): string {
    return 'DraftsComponent';
  }

  createForm() {
    this.switchDraft = this.switchDraft ? this.switchDraft : this.fb.group({});

    this.switchDraft.addControl('onlyMyDraft', new FormControl(true
    ));

    this.switchDraft.markAsPristine();
  }

  search(criteriaDto: DraftsResearchModel): Observable<Array<DraftModel>> {
    return this.draftsService.find(criteriaDto);
  }

  openProcess(draft: DraftModel) {
    if (!this.checkSameOperator(draft)) {
      this.messageService.throwMessageSimple('PRIVATE_DRAFT_ALERT_MESSAGE', MessageType.WARNING_MESSAGE);
      return;
    }
    this.router.navigate(['orders', 'new-order'], {queryParams: {pid: draft.processId}});
  }

  checkSameOperator(draft: DraftModel) {
    if (draft.operator?.identityId && this.usersService.getUser().identityId) {
      if (draft.operator?.identityId !== this.usersService.getUser().identityId) {
        return false;
      }
    }
    if (draft.operator?.uida && this.usersService.getUser().uida) {
      if (draft.operator?.uida !== this.usersService.getUser().uida) {
        return false;
      }
    }
    return true;
  }

  onEdit(draft: DraftModel) {
    this.draftToEdit = draft;
    this.modalService.open('edit-draft-modal');
  }

  onEditedDraft() {
    this.startSearchLoading();

    this.search(this.buildCriteriaDto())
      .subscribe((res) => {
          this.searchResults = res;
          this.draftToEdit = null;
          this.stopSearchLoading();
        },
        err => {
          this.stopSearchLoading();
          this.draftToEdit = null;
        });
  }

  onDelete(draft: DraftModel) {
    $('body').on('click', (e) => {
      $('[data-toggle=popover]').each(() => {
        // hide any open popovers when the anywhere else in the body is clicked
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
          // e.preventDefault();
          $('#draft' + draft.processId).popover('hide');
          if (!draft.deleteMode) {
            // $('body').off();
            return;
          }
        }
      });
    });

    draft.deleteMode = true;

    setTimeout(() => {
      $('#draft' + draft.processId).popover({
        trigger: 'focus'
      });
      $('#draft' + draft.processId).popover('toggle');
    }, 0);

    setTimeout(() => {
      $('#draft' + draft.processId).on('hidden.bs.popover', () => {
        draft.deleteMode = false;
        $('#draft' + draft.processId).popover('hide');
      });
    }, 0);
  }

  onDeleteConfirm(draft: DraftModel) {
    this.startSearchLoading();
    this.draftsService.deleteDraft(draft.processId).subscribe(() => {
      this.search(this.buildCriteriaDto())
        .subscribe((res) => {
          this.searchResults = res;
          this.stopSearchLoading();
        });
    }, error => {
      this.stopSearchLoading();
      draft.deleteMode = false;
    });
  }

  onSwitch() {
    this.startSearchLoading();
    this.search(this.buildCriteriaDto())
      .subscribe((res) => {
          this.searchResults = res;
          this.stopSearchLoading();
        },
        err => {
          this.stopSearchLoading();
        });
  }

  openDrafts() {
    this.router.navigate(['orders', 'drafts']);
  }
}
